import { Pencil, Trash2 } from 'lucide-react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../../hooks/useStore';
import type { IUserManagementResult } from '../../../../models/user-management/UserManagementModel';
import styles from '../UserManagement.module.css';

export type UsersActionCellProps = {
  row: IUserManagementResult;
};

const UsersActionCell = ({ row }: UsersActionCellProps) => {
  const { popupStore, userManagementStore } = useStore();

  const handleEdit = (e: React.MouseEvent) => {
    e.stopPropagation();
    userManagementStore.setSelectedUser(row);
    popupStore.setIsEditUserOpen(true);
  };

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    userManagementStore.setSelectedUser(row);
    popupStore.setIsDeleteUserConfirmationOpen(true);
  };

  return (
    <div className={styles.actionCell}>
      <button onClick={handleEdit} className={styles.editButton} title="Düzenle">
        <Pencil size={16} strokeWidth={2} />
      </button>
      <button onClick={handleDelete} className={styles.deleteButton} title="Sil">
        <Trash2 size={16} strokeWidth={2} />
      </button>
    </div>
  );
};

export default observer(UsersActionCell);
